









import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class SyText extends Vue {
  @Prop() showType!: string;
  @Prop() value!: string;
  @Prop() title!: string;
  @Prop() type!: string;
}
